import RegisterField, { FieldProps } from "../register-field";
import { PasswordField, PasswordFieldProps } from "@/components/inputs";

export default function FormPasswordField({
    name,
    registerOptions,
    ...props
}: FieldProps<PasswordFieldProps>) {
    return <RegisterField name={name} disabled={props.disabled} {...registerOptions}>
        {field => <PasswordField
            {...props}

            inputRef={field.ref}
            value={field.value}
            disabled={field.disabled}

            onChange={e => {
                field.handleChange(e.target.value);
                props.onChange && props.onChange(e);
            }}
            onBlur={e => {
                field.handleBlur();
                props.onBlur && props.onBlur(e);
            }}
            onKeyDown={e => {
                props.onKeyDown && props.onKeyDown(e);
                field.handleKeyDown(e);
            }}

            error={field.hasError}
            helperText={field.errorMessage}
        />}
    </RegisterField>
}